module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"capturedErrorMsg":"An unexpected error occured within the webbrowser during processing or rendering of this webpage.","error":"Error","errorDetails":"Error Details: "},"de":{"capturedErrorMsg":"Es ist leider ein unerwarteter Fehler bei der Verarbeitung und Anzeige dieser Webseite im Browser aufgetreten.","error":"Fehler","errorDetails":"Fehlerbeschreibung: "}}')
  delete Component.options._Ctor
}
